import {
  type FunctionComponent,
  type ReactNode,
  useEffect,
  useEffectEvent,
  useRef,
} from 'react';

import S from './style.scss';

type PropsT = {
  children: ReactNode;
  onGrowthH: () => void;
  source: 'AI' | 'LISTENING' | 'SYSTEM_ERROR' | 'SYSTEM_WARNING' | 'USER';
};

// TODO: Hook it up to the actual microphone input signal!
export const Message: FunctionComponent<PropsT> = ({
  children,
  onGrowthH,
  source,
}) => {
  let containerClassName = S.container;

  const ref = useRef<HTMLDivElement>(null);

  const growth = useEffectEvent(onGrowthH);

  useEffect(() => {
    const div = ref.current;
    let observer: ResizeObserver | undefined;
    if (div) {
      let lastH = div.offsetHeight;
      observer = new ResizeObserver(() => {
        const h = div.offsetHeight;
        if (lastH < h) {
          lastH = h;
          growth();
        }
      });
      observer.observe(div);
    }
    return () => {
      observer?.disconnect();
    };
  }, []);

  switch (source) {
    case 'AI':
      containerClassName += ` ${S.ai}`;
      break;
    case 'LISTENING':
      containerClassName += ` ${S.listening}`;
      break;
    case 'SYSTEM_ERROR':
      containerClassName += ` ${S.systemError}`;
      break;
    case 'SYSTEM_WARNING':
      containerClassName += ` ${S.systemWarning}`;
      break;
    case 'USER':
      containerClassName += ` ${S.user}`;
      break;
    default: throw Error('Unexpected case');
  }

  return (
    <div className={containerClassName} ref={ref}>
      {children}
    </div>
  );
};
